// Shown when a sea sync is BLOCKED because a port record has no usable 3-char code / 5-char UN/LOCODE.
// Nothing was sent to BoxTop. There is deliberately no "send anyway": a port written as plain text leaves staff
// re-picking it in BoxTop, which is the problem this block exists to prevent.
export interface PortProblem { side: 'Origin' | 'Destination'; portName: string | null; reason: string }

interface Props { jobRef: string; problems: PortProblem[]; onClose: () => void }

export default function PortCodeProblemDialog({ jobRef, problems, onClose }: Props) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" onClick={onClose}>
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-xl w-full max-w-lg p-6" onClick={e => e.stopPropagation()}>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-1">Not synced — port code missing ({jobRef})</h2>
        <p className="text-sm text-gray-600 dark:text-gray-300 mb-3">Nothing was sent to BoxTop. BoxTop needs the port's 3-character code and 5-character UN/LOCODE to link its own port record; sending the name alone would leave you re-picking the port in BoxTop.</p>
        <ul className="space-y-2 mb-4">
          {problems.map(p => (
            <li key={p.side} className="border border-red-200 dark:border-red-700 bg-red-50 dark:bg-red-900/20 rounded-lg px-3 py-2 text-sm text-red-800 dark:text-red-300">
              <strong>{p.side} port{p.portName ? ` — ${p.portName}` : ''}:</strong> {p.reason}
            </li>
          ))}
        </ul>
        <p className="text-xs text-gray-500 dark:text-gray-400 mb-4">Fix: change the job's port to the complete record (code like <code>YTN</code> and UN/LOCODE like <code>CNYTN</code>), or complete that port under Data → Ports, then sync again.</p>
        <div className="flex justify-end"><button onClick={onClose} className="px-4 py-2 text-sm rounded-lg bg-gray-100 hover:bg-gray-200 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-100">Close</button></div>
      </div>
    </div>
  )
}
